module.exports = __webpack_public_path__ + "static/media/vegetable-white.53608ee6.svg";